import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import './contact.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope} from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Fade, Slide } from 'react-awesome-reveal';

export const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_dutctqy', 'template_w42p1np', form.current, '2cuemVKQIuPXp3KTF')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });

    e.target.reset();
  };

  return (
    // <form ref={form} onSubmit={sendEmail}>
    //   <label>Name</label>
    //   <input type="text" name="user_name" />
    //   <label>Email</label>
    //   <input type="email" name="user_email" />
    //   <label>Message</label>
    //   <textarea name="message" />
    //   <input type="submit" value="Send" />
    // </form>
    
    <section className='contactSection'>
      <Fade>
        <div className="betterTogether">
            <h1 style={{textAlign:'center', color:'white', fontSize:'5rem'}}>Better Together</h1>
        </div>
      </Fade>
      <Fade cascade>
        <div className="contactContent row" style={{display:'flex', justifyContent:'space-around',alignItems:'center',color:'white', flexWrap:"wrap-reverse"}}>
          <div className="letsConnect col-sm-12 col-md-6">
            <div className='letsConnectContent'>
              <h1 style={{fontSize:'3rem'}}>Let's Connect !</h1>
              <h1>Tell me about your <br></br>Project</h1>
              <h6>We can create something together</h6>
              <br />
              <div className="contactIcons">
                <div>
                <a href="mailto:gbhardwaj869@gmail.com"><FontAwesomeIcon icon={faEnvelope} beat size="2xl" style={{color: "#ffffff",}} /></a>
                <a href='https://www.facebook.com/profile.php?id=100074151492709'><FontAwesomeIcon icon={faFacebook} beat size="2xl" style={{color: "#ffffff",}} /></a>
                <a href='https://www.linkedin.com/in/gaurav-bhardwaj-5475b022a/'><FontAwesomeIcon icon={faLinkedin} beat size="2xl" style={{color: "#ffffff",}} /></a>
                </div>
              </div>
            </div>
          </div>
          <div className="ContactFormSection col-sm-12 col-md-6">
            <h2>Send me a message</h2>
          <form ref={form} onSubmit={sendEmail} className='contactForm'>
            <div className="form-group" style={{display:'flex', justifyContent:'space-between'}}>
              <input
                type="text"
                id="name"
                name="user_name"
                placeholder='Your Name'
                required
                style={{marginRight:5}}
              />
              <input
                type="email"
                id="email"
                name="user_email"
                placeholder='Your email'
                required
                style={{marginLeft:5}}
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                id="subject"
                name="subject"
                placeholder='Subject'
                required
              />
            </div>
            <div className="form-group">
              <textarea
                id="message"
                rows="4"
                name="message"
                placeholder='Message'
                required
              />
            </div>
            <div className='btnContainer'>
              <button class="sendButton" type='submit'><span> Send </span></button>
            </div>
          </form>
          </div>
        </div>
      </Fade>

      <h1 style={{color:'white', fontSize:'1.5rem', textAlign:'center'}}>Gaurav Bhardwaj | IIT Kharagpur</h1>
    </section>
  );
};